<template>
  <div v-loading="contentLoading">
    <div class="title">
      基本信息
    </div>
    <table cellspacing="0" cellpadding="0" style="width: 100%" class="ReserveOrderTable">
      <tr>
        <td class="tableLabel">申请编号</td>
        <td class="tableContent">{{form.invoiceApplicationNo}}</td>
        <td class="tableLabel">申请状态</td>
        <td class="tableContent">
          <span v-if="form.status===0">草稿</span>
          <span v-if="form.status===1">已提交</span>
          <span v-if="form.status===2">已处理</span>
        </td>
        <td class="tableLabel">标识</td>
        <td class="tableContent">{{form.sign}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户名称</td>
        <td class="tableContent">
          <el-input v-model="form.customerName" readonly placeholder="请选择客户" :disabled="form.sign==='销售'">
            <el-button slot="append" :disabled="form.sign==='销售' || !edit" @click="$refs.selectCustomerName.open()">
              选择
            </el-button>
          </el-input>
          <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
        </td>
        <td class="tableLabel">客户税号</td>
        <td class="tableContent">{{form.invoiceVATNO}}</td>
        <td class="tableLabel">银行账号</td>
        <td class="tableContent">{{form.invoiceAccounts}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户编号</td>
        <td class="tableContent">{{form.customerNo}}</td>
        <td class="tableLabel">地址</td>
        <td class="tableContent">{{form.invoiceAddress}}</td>
        <td class="tableLabel">邮箱</td>
        <td class="tableContent">
          <el-input v-model="form.email" :disabled="!edit" placeholder="邮箱"/>
        </td>
      </tr>
      <tr>
        <td class="tableLabel">财务凭证号</td>
        <td class="tableContent">
          <el-input v-model="form.financialVouchers" :disabled="!edit || form.sign==='销售'" placeholder="财务凭证号"/>
        </td>
        <td class="tableLabel">软著信息</td>
        <td class="tableContent">
          <el-select v-model="form.softInfo" :disabled="!edit" @change="softInfoChange">
            <el-option label="开具软著" :value="1"/>
            <el-option label="不开软著" :value="0"/>
          </el-select>
        </td>
        <td class="tableLabel">申请人</td>
        <td class="tableContent">{{form.creatorName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">申请日期</td>
        <td class="tableContent">{{form.createTime}}</td>
        <td class="tableLabel">提交日期</td>
        <td class="tableContent">{{form.submitTime}}</td>
        <td class="tableLabel">通过日期</td>
        <td class="tableContent">{{form.passTime}}</td>
      </tr>
      <tr>
        <td class="tableLabel">发票类型</td>
        <td class="tableContent">
          <el-select v-model="form.invoiceType" :disabled="!edit">
            <el-option label="全电专" :value="'05'"/>
            <el-option label="全电普" :value="'06'"/>
          </el-select>
        </td>
        <td class="tableLabel">发票状态</td>
        <td class="tableContent">
          <el-select v-model="form.invoiceStatus" :disabled="!edit">
            <el-option label="蓝票" :value="'1'"/>
            <el-option label="红票" :value="'2'"/>
          </el-select>
        </td>
        <td class="tableLabel">冲销金税票号</td>
        <td class="tableContent">
          <el-input v-model="form.referencecode" :disabled="form.invoiceStatus==='1'"/>
        </td>
      </tr>
      <tr v-if="form.invoiceStatus === '2'">
        <td class="tableLabel">红字冲销原因</td>
        <td class="tableContent">
          <el-select v-model="form.offsetReason" :disabled="!edit" prop="offsetReason">
            <el-option label="开票错误" :value="'1'"/>
            <el-option label="销售退回" :value="'2'"/>
            <el-option label="销售折让" :value="'3'"/>
            <el-option label="发票管理问题" :value="'4'"/>
          </el-select>
        </td>
        <td class="tableLabel">红冲方式</td>
        <td class="tableContent">
          <el-select v-model="form.offsetMethod" :disabled="!edit">
            <el-option label="全部红冲" :value="'1'"/>
            <el-option label="部分红冲" :value="'2'"/>
          </el-select>
        </td>
        <td class="tableLabel">红字通知单</td>
        <td class="tableContent">
          <el-input v-model="form.offsetNoticeNo" :disabled="!edit"/>
        </td>
      </tr>
      <tr>
        <td class="tableLabel">开票不含税金额</td>
        <td class="tableContent">{{form.totalNetPrice}}</td>
        <td class="tableLabel">税额</td>
        <td class="tableContent">{{form.totalTaxPrice}}</td>
        <td class="tableLabel">开票金额</td>
        <td class="tableContent">{{form.invoiceTotalAmount}}</td>
      </tr>
      <tr>
        <td class="tableLabel">备注</td>
        <td class="tableContent" colspan="6">
          <el-input v-model="form.note" :disabled="!edit" placeholder="备注"/>
        </td>
      </tr>
    </table>
    <div v-if="form.sign==='销售'">
      <template v-if="edit && !isEdit">
        <el-button
            style="margin-top: 10px"
            :disabled="deliverySelection.length === 0 && saleOrderSelection.length === 0"
            type="primary"
            :loading="btnItemLoading"
            @click="addSapInvoice">
          明细开票
        </el-button>
        <el-button
            :disabled="deliverySelection.length === 0 && saleOrderSelection.length === 0"
            type="primary"
            :loading="btnDifMaterialLoading"
            @click="countSapInvoice">
          汇总开票(不同物料)
        </el-button>
        <el-button
            :disabled="deliverySelection.length === 0 && saleOrderSelection.length === 0"
            type="primary"
            :loading="btnMaterialLoading"
            @click="countSapInvoiceByOtherNOByV2">
          汇总开票(相同物料)
        </el-button>
      </template>
      <div v-if="deliveryList.length>0">
        <div
            style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          关联发货单列表
        </div>
        <el-table
            ref="refDelivery"
            :data="deliveryList"
            :border="true"
            :max-height="600"
            stripe
            @select="deliverySelectHandle"
            @select-all="deliverySelectHandle">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column type="index" align="center" label="#"/>
          <el-table-column prop="billNo" align="center" label="单号" width="100"/>
          <el-table-column prop="rowIndex" align="center" label="行项" width="100"/>
          <el-table-column prop="materialNo" align="center" label="物料号" width="100"/>
          <el-table-column prop="materialName" align="center" label="物料名称" width="200"/>
          <el-table-column prop="specifications" align="center" label="规格型号"/>
          <el-table-column prop="manufacturerModel" align="center" label="厂家型号"/>
          <el-table-column prop="sapProductName" align="center" label="开票名称"/>
          <el-table-column prop="quantity" align="center" label="数量" width="120">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.quantity"
                  style="width: 100%"
                  :disabled="!edit || isEdit || scope.row.quantity <= 0"
                  :max="edit ? scope.row.initQuantity > 0 ? scope.row.initQuantity : -1 : scope.row.quantity"
                  :min="edit ? scope.row.initQuantity > 0 ? 1 : scope.row.initQuantity : scope.row.quantity"
                  @change="changeQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" align="center" label="单价(含税)" width="100"/>
          <el-table-column prop="totalNetPrice" align="center" label="总价(不含税)" width="100"/>
          <el-table-column prop="totalPrice" align="center" label="总价(含税)" width="100"/>
          <el-table-column prop="taxRate" align="center" label="税率" width="100">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.taxRate"
                  :disabled="!edit || isEdit"
                  placeholder="请输入税率"
                  @change="changeQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="softInfo" align="center" label="软著信息"/>
          <el-table-column prop="give" align="center" label="赠送标识"/>
          <el-table-column align="center" label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                  v-if="scope.row.quantity > 0"
                  type="text"
                  size="small"
                  :disabled="!edit || isEdit"
                  @click="splitDetail(scope.row, 'delivery')"
              >
                明细拆分
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="saleOrderList.length>0">
        <div
            style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          关联销售订单列表
        </div>
        <el-table
            ref="refSaleOrder"
            :data="saleOrderList"
            :border="true"
            :max-height="600"
            stripe
            @select="saleOrderSelectHandle"
            @select-all="saleOrderSelectHandle">
          <el-table-column type="selection" align="center" width="55"/>
          <el-table-column type="index" align="center" label="#"/>
          <el-table-column prop="billNo" align="center" label="单号"/>
          <el-table-column prop="rowIndex" align="center" label="行项"/>
          <el-table-column prop="materialNo" align="center" label="物料号"/>
          <el-table-column prop="materialName" align="center" label="物料名称"/>
          <el-table-column prop="specifications" align="center" label="规格型号"/>
          <el-table-column prop="manufacturerModel" align="center" label="厂家型号"/>
          <el-table-column prop="sapProductName" align="center" label="开票名称"/>
          <el-table-column prop="quantity" align="center" label="数量" width="120">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.quantity"
                  style="width: 100%"
                  :disabled="!edit || isEdit || scope.row.quantity <= 0"
                  :max="edit ? scope.row.initQuantity > 0 ? scope.row.initQuantity : -1 : scope.row.quantity"
                  :min="edit ? scope.row.initQuantity > 0 ? 1 : scope.row.initQuantity : scope.row.quantity"
                  @change="changeQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="unit" align="center" label="单位"/>
          <el-table-column prop="unitPrice" align="center" label="单价(含税)"/>
          <el-table-column prop="totalPrice" align="center" label="总价(含税)"/>
          <el-table-column prop="taxRate" align="center" label="税率" width="100">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.taxRate"
                  :disabled="!edit || isEdit"
                  placeholder="请输入税率"
                  @change="changeQuantity(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="softInfo" align="center" label="软著信息"/>
          <el-table-column align="center" label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                  v-if="scope.row.quantity > 0"
                  type="text"
                  size="small"
                  :disabled="!edit || isEdit"
                  @click="splitDetail(scope.row, 'sale')"
              >
                明细拆分
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
        style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between">
      <div>开票信息</div>
      <div style="display: flex; gap: 20px;">
        <div>不含税总金额：<span style="color: red;">￥{{detailsTotalNetPrice}}</span></div>
        <div>总税额：<span style="color: red;">￥{{detailsTotalTaxPrice}}</span></div> 
        <div>总金额：<span style="color: red;">￥{{detailsInvoiceTotalAmount}}</span></div>
      </div>
    </div>
    <el-button v-if="edit && !isEdit" type="primary" style="margin-bottom: 5px" @click="addFinancialDetails">
      添加
    </el-button>
    <div v-if="form.sign==='销售'">
      <el-table
          :data="form.details"
          :border="true"
          :max-height="600"
          stripe>
        <el-table-column fixed="left" type="expand">
          <template slot-scope="props">
            <el-table
                :data="(props.row.deliveryList || []).concat(props.row.saleOrderList || [])"
                style="width: 100%;margin: 0 auto">
              <el-table-column type="index" align="center" label="行项"/>
              <el-table-column prop="type" align="center" label="类型"/>
              <el-table-column prop="billNo" align="center" label="单号"/>
              <el-table-column prop="materialNo" align="center" label="物料编号"/>
              <el-table-column prop="materialName" width="220" align="center" label="物料描述"/>
              <el-table-column prop="specifications" align="center" label="规格型号"/>
              <el-table-column prop="manufacturerModel" align="center" label="厂家型号"/>
              <el-table-column prop="sapProductName" align="center" label="开票名称"/>
              <el-table-column prop="unit" align="center" label="单位"/>
              <el-table-column prop="quantity" align="center" label="数量"/>
              <el-table-column prop="unitPrice" align="center" label="开票单价"/>
              <el-table-column prop="totalPrice" align="center" label="开票总额(含税)"/>
              <el-table-column prop="totalNetPrice" align="center" label="开票总额(不含税)"/>
              <el-table-column prop="totalTaxPrice" align="center" label="税额"/>
              <el-table-column prop="note" align="center" label="备注"/>
            </el-table>
            <!-- <el-table
                v-if="props.row.saleOrderList && props.row.saleOrderList.length > 0"
                :data="props.row.saleOrderList"
                style="width: 100%;margin: 0 auto">
              <el-table-column type="index" align="center" label="行项"/>
              <el-table-column prop="type" align="center" label="类型"/>
              <el-table-column prop="billNo" align="center" label="单号"/>
              <el-table-column prop="materialNo" align="center" label="物料编号"/>
              <el-table-column prop="materialName" width="220" align="center" label="物料描述"/>
              <el-table-column prop="specifications" align="center" label="规格型号"/>
              <el-table-column prop="manufacturerModel" align="center" label="厂家型号"/>
              <el-table-column prop="sapProductName" align="center" label="开票名称"/>
              <el-table-column prop="unit" align="center" label="单位"/>
              <el-table-column prop="quantity" align="center" label="数量"/>
              <el-table-column prop="unitPrice" align="center" label="开票单价"/>
              <el-table-column prop="totalPrice" align="center" label="开票总额(含税)"/>
              <el-table-column prop="totalNetPrice" align="center" label="开票总额(不含税)"/>
              <el-table-column prop="totalTaxPrice" align="center" label="税额"/>
              <el-table-column prop="note" align="center" label="备注"/>
            </el-table> -->
          </template>
        </el-table-column>
        <el-table-column type="index" align="center" label="行项"/>
        <el-table-column prop="type" align="center" label="类型"/>
        <el-table-column prop="invoiceContent" align="center" label="开票名称" width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.invoiceContent"
                autosize
                :disabled="!edit"
                placeholder="请输入开票名称"
                type="textarea"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialNo" align="center" label="物料编号" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" :disabled="!edit" placeholder="请输入物料编号"/>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" width="220" align="center" label="物料描述">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.materialName"
                :disabled="!edit"
                placeholder="请输入物料描述"/>
          </template>
        </el-table-column>
        <el-table-column prop="specifications" align="center" label="规格型号" width="200">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.specifications"
                :disabled="!edit"
                placeholder="请输入规格型号"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" align="center" label="单位" width="80">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" :disabled="!edit" placeholder="请输入单位"/>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="数量" width="80">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.quantity"
                :disabled="!edit"
                placeholder="数量"
                @change="handleInvoiceCountChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" align="center" label="开票单价" width="100">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.unitPrice"
                :disabled="!edit"
                placeholder="请输入"
                @change="handleInvoiceCountChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="totalNetPrice" align="center" label="开票总额(不含税)" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.totalNetPrice"
                :disabled="!edit"
                placeholder="请输入"
                @change="calculateInvoiceTotalPrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="totalTaxPrice" align="center" label="税额" width="100">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.totalTaxPrice"
                :disabled="!edit"
                placeholder="请输入"
                @change="calculateInvoiceTotalPrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="totalPrice" align="center" label="开票总额(含税)" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.totalPrice"
                :disabled="!edit"
                placeholder="请输入"
                @change="calcuteItemFinalPrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="discount" align="center" label="折扣额(含税总额)" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.discount"
                :disabled="!edit"
                placeholder="请输入"
                @change="calculateDiscountTaxPrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="discountTaxPrice" align="center" label="折扣税额" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.discountTaxPrice"
                :disabled="!edit"
                placeholder="请输入"
                @change="calcuteItemFinalPrice(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column prop="finalTotalPrice" align="center" label="实际开票金额(含税)" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.finalTotalPrice"
                :disabled="!edit"
                placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="finalTotalTaxPrice" align="center" label="实际税额" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.finalTotalTaxPrice"
                :disabled="!edit"
                placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="finalTotalNetPrice" align="center" label="实际开票金额(不含税)" width="150">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.finalTotalNetPrice"
                :disabled="!edit"
                placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="taxRate" align="center" label="税率" width="100">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.taxRate"
                :disabled="!edit"
                placeholder="请输入"
                @change="handleInvoiceTaxChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="taxTypeName"
            align="center"
            label="税收分类品名"
            width="150"
            fixed="right">
          <template slot-scope="scope">
            <el-select
                v-model="scope.row.taxTypeName"
                value-key="typeName"
                filterable
                remote
                :remote-method="(query) => remoteTaxTypeSearch(query, scope.row)"
                :loading="taxTypeLoading"
                style="max-width: 200px"
                :disabled="!edit"
                placeholder="输入关键字"
                @change="(value) => selectCode(scope.row, value)">
              <el-option
                  v-for="item in scope.row.taxTypeSource"
                  :key="item.pkid"
                  :label="item.typeName"
                  :value="item.typeName"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            prop="taxTypeCode"
            align="center"
            label="税收分类编码"
            width="150"
            fixed="right"/>
        <el-table-column prop="note" align="center" label="备注">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.note"
                :disabled="!edit"
                placeholder="请输入备注"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button :disabled="!edit || isEdit" type="primary" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-table
        v-else
        :data="form.details"
        :border="true"
        stripe>
      <el-table-column type="index" align="center" label="行项"/>
      <el-table-column prop="invoiceContent" align="center" label="开票名称">
        <template slot-scope="scope">
          <el-input v-model="scope.row.invoiceContent" :disabled="!edit" placeholder="请输入开票名称"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialNo" align="center" label="物料编号">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialNo" :disabled="!edit" placeholder="请输入物料编号"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" width="220" align="center" label="物料描述">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialName" :disabled="!edit" placeholder="请输入物料描述"/>
        </template>
      </el-table-column>
      <el-table-column prop="specifications" align="center" label="规格型号">
        <template slot-scope="scope">
          <el-input v-model="scope.row.specifications" :disabled="!edit" placeholder="请输入规格型号"/>
        </template>
      </el-table-column>
      <el-table-column prop="unit" align="center" label="单位">
        <template slot-scope="scope">
          <el-input v-model="scope.row.unit" :disabled="!edit" placeholder="请输入单位"/>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" align="center" label="数量">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.quantity"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" align="center" label="开票单价">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.unitPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="totalNetPrice" align="center" label="开票总额(不含税)" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.totalNetPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="totalTaxPrice" align="center" label="税额" width="100">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.totalTaxPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="totalPrice" align="center" label="开票总额(含税)" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.totalPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="discount" align="center" label="折扣额(含税总额)" width="150">
        <template slot-scope="scope">
          <el-input v-model="scope.row.discount" :disabled="!edit" placeholder="请输入折扣额"/>
        </template>
      </el-table-column>
      <el-table-column prop="discountTaxPrice" align="center" label="折扣税额" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.discountTaxPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="finalTotalPrice" align="center" label="实际开票金额(含税)" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.finalTotalPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="finalTotalTaxPrice" align="center" label="实际税额" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.finalTotalTaxPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="finalTotalNetPrice" align="center" label="实际开票金额(不含税)" width="150">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.finalTotalNetPrice"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column prop="taxRate" align="center" label="税率" width="100">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.taxRate"
              :disabled="!edit"
              placeholder="请输入"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="taxTypeName"
          align="center"
          label="税收分类品名"
          width="150"
          fixed="right">
        <template slot-scope="scope">
          <el-select
              v-model="scope.row.taxTypeName"
              value-key="typeName"
              filterable
              remote
              :remote-method="(query) => remoteTaxTypeSearch(query, scope.row)"
              :loading="taxTypeLoading"
              style="max-width: 200px"
              :disabled="!edit"
              placeholder="输入关键字"
              @change="(value) => selectCode(scope.row, value)">
            <el-option
                v-for="item in scope.row.taxTypeSource"
                :key="item.pkid"
                :label="item.typeName"
                :value="item.typeName"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="taxTypeCode"
          align="center"
          label="税收分类编码"
          width="150"
          fixed="right"/>
      <el-table-column prop="note" align="center" label="备注">
        <template slot-scope="scope">
          <el-input v-model="scope.row.note" :disabled="!edit" placeholder="请输入备注"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button :disabled="!edit || isEdit" type="primary" @click="deleteRowByFinancial(scope.$index,scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <div v-if="edit && !isEdit">
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="uploadLoading"
            style="display: inline-block; margin: 5px;">
          <el-button type="primary">
            <i class="el-icon-upload el-icon--right"/>
            附件上传
          </el-button>
        </el-upload>
      </div>
      <el-table ref="payData1" border :data="form.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
        <el-table-column label="下载" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注"/>
      </el-table>
    </div>
    <div style="text-align: right">
      <span v-if="edit" slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
        <!--        <el-button type="primary" :loading="submitLoading" @click="submit">提交</el-button>-->
      </span>
    </div>
    <!-- 明细拆分弹窗 -->
    <detail-split-dialog
        :visible="splitDialogVisible"
        :detail-data="splitDetailData"
        :detail-type="splitDetailType"
        @close="splitDialogVisible = false"
        @confirm="handleSplitConfirm"
    />
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import DetailSplitDialog from "./DetailSplitDialog.vue";

  export default {
    name: "InvoiceApplicationPreview",
    components: {CustomerSelect, DetailSplitDialog},
    props: {
      isEditPage: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        taxTypeSource: [],
        filteredTaxTypeSource: [],
        taxTypeLoading: false,
        downLoadLoading: false,
        deliverySelection: [],
        saleOrderSelection: [],
        btnItemLoading: false, // 明细开票loading
        btnDifMaterialLoading: false, // 汇总开票(不同物料)loading
        btnMaterialLoading: false, // 汇总开票(相同物料)loading
        contentLoading: false,
        pkid: "",
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 0,
        isEdit: false,
        // 明细拆分弹窗相关
        splitDialogVisible: false,
        splitDetailData: {},
        splitDetailType: "delivery",
        splitList: [],
        editBillId: "", // 记录当前编辑的billId
        routeSelection: null,
        routeCancelId: "",
        routeBillId: "",
        form: {
          pkId: 0,
          billNo: "",
          customerId: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          invoiceAddress: "",
          invoiceAccounts: "",
          financialVouchers: "",
          email: "",
          sign: "财务",
          invoiceTotalAmount: "",
          note: "",
          details: [],
          totalNetPrice: "",
          totalTaxPrice: "",
          invoiceType: "05",
          invoiceStatus: "1",
          referencecode: "",
          softInfo: "",
          sourcePytStatus:"",
          cancelSign:false,
        },
        deliveryList: [],
        saleOrderList: [],
        allList: [],
        ruleValidate: {},
        isShowDetail: true,
        finalData: [],
        tempTableData: [],
        tableData: [],
      };
    },
    computed: {
      // 不含税总金额
      detailsTotalNetPrice() {
        return this.form.details.reduce((total, item) => {
          const netPrice = parseFloat(item.finalTotalNetPrice) || 0;
          return total + netPrice;
        }, 0).toFixed(2);
      },
      // 总税额
      detailsTotalTaxPrice() {
        return this.form.details.reduce((total, item) => {
          const taxPrice = parseFloat(item.finalTotalTaxPrice) || 0;
          return total + taxPrice;
        }, 0).toFixed(2);
      },
      // 总金额
      detailsInvoiceTotalAmount() {
        return this.form.details.reduce((total, item) => {
          const price = parseFloat(item.finalTotalPrice) || 0;
          return total + price;
        }, 0).toFixed(2);
      },
    },

    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "InvoiceApplicationPreview") {
            this.isEdit = false;
            this.getData(this.$route.query.billId, this.$route.query.selection, this.$route.query.cancelId);
          } else if (val.name === "InvoiceApplicationEdit") {
            this.isEdit = true;
            this.edit = 1;
            if(this.editBillId !== val.query.billId) {
              this.getEditData(this.$route.query.billId);
              this.editBillId = val.query.billId;
            }
          }
        },
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.getTaxType();
        if(!this.isEditPage) {
          this.isEdit = false;
          this.getData(this.$route.query.billId, this.$route.query.selection, this.$route.query.cancelId);
          this.routeSelection = this.$route.query.selection.map(item => item.type + item.billId).join("*");
          this.routeCancelId = this.$route.query.cancelId;
          this.routeBillId = this.$route.query.billId;
        } else {
          this.isEdit = true;
          this.edit = 1;
          this.getEditData(this.$route.query.billId);
          this.editBillId = this.$route.query.billId; // 用于路由变化是，判断是否要请求新数据
        }
      });
    },

    methods: {
      getTaxType() {
        this.$http.get("basic", "invoiceApplicationTypes/list").then((resp) => {
          this.taxTypeSource = resp.data;
        });
      },
      remoteTaxTypeSearch(query, row) {
        if (query !== "") {
          this.taxTypeLoading = true;
          // 模拟远程搜索，实际是在本地过滤
          setTimeout(() => {
            row.taxTypeSource = this.taxTypeSource.filter(item => {
              return item.typeName.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
            this.taxTypeLoading = false;
          }, 200);
        } else {
          row.taxTypeSource = null;
        }
      },
      // 获取行键值
      getRowKey() {
        return new Date().getTime().toString() + Math.floor(Math.random() * 10000) + 1;
      },
      // 添加发货单明细的通用字段
      addDeliveryCommonItem(item, invoiceContent) {
        return {
          invoiceContent: invoiceContent || "",
          materialNo: item.materialNo,
          materialName: item.materialName,
          specifications: item.specifications,
          manufacturerModel: item.manufacturerModel,
          sapProductName: item.sapProductName,
          softInfo: item.softInfo,
          unit: item.unit,
          quantity: item.quantity,
          initQuantity: item.initQuantity,
          unitPrice: item.unitPrice,
          totalNetPrice: item.totalNetPrice,
          totalPrice: item.totalPrice,
          totalTaxPrice: parseFloat(item.totalPrice - item.totalNetPrice).toFixed(2),
          note: item.note || "",
          taxRate: item.taxRate || 13,
          rowIndex: item.rowIndex,
          billNo: item.billNo,
          type: "发货单",
          deliveryBillId: item.deliveryBillId,
          deliveryDetailId: item.deliveryDetailId,
          sapSaleOrderNo: item.sapSaleOrderNo,
          salesOrderRowIndex: item.salesOrderRowIndex,
          splitIndex: item.splitIndex,
        };
      },
      // 添加发货单明细的通用字段
      addSaleOrderCommonItem(item, invoiceContent) {
        return {
          invoiceContent: invoiceContent || "",
          materialNo: item.materialNo,
          materialName: item.materialName,
          specifications: item.specifications,
          manufacturerModel: item.manufacturerModel,
          sapProductName: item.sapProductName,
          softInfo: item.softInfo,
          unit: item.unit,
          quantity: item.quantity,
          initQuantity: item.initQuantity,
          unitPrice: item.unitPrice,
          totalNetPrice: item.totalNetPrice,
          totalPrice: parseFloat(item.quantity * item.unitPrice).toFixed(2),
          totalTaxPrice: parseFloat(item.totalPrice - item.totalNetPrice).toFixed(2),
          note: item.note || "",
          taxRate: item.taxRate || 13,
          rowIndex: item.rowIndex,
          billNo: item.billNo,
          type: "销售订单",
          saleOrderId: item.saleOrderId,
          saleOrderDetailId: item.saleOrderDetailId,
          sapSaleOrderNo: item.sapSaleOrderNo,
          salesOrderRowIndex: item.salesOrderRowIndex,
          splitIndex: item.splitIndex,
        };
      },
      // 添加明细开票的通用字段
      addInvoiceCommonItem(item, invoiceContent) {
        let matchTaxType = {};
        matchTaxType = this.getTaxTypeCodeByName(item.sapProductName);
        const discount = item.discount || 0;
        const discountTaxPrice = item.discountTaxPrice || 0;
        const discountNetPrice = discount - discountTaxPrice;
        const totalPrice = parseFloat(item.totalPrice) || 0;
        const totalNetPrice = parseFloat(item.totalNetPrice) || 0;
        const totalTaxPrice = (parseFloat(item.totalPrice) - parseFloat(item.totalNetPrice)).toFixed(2) || 0;
        const finalTotalPrice = parseFloat(totalPrice) + parseFloat(discount);
        const finalTotalTaxPrice = parseFloat(totalTaxPrice) + parseFloat(discountTaxPrice);
        const finalTotalNetPrice = parseFloat(totalNetPrice) + parseFloat(discountNetPrice);
        return {
          invoiceContent: invoiceContent || "",
          materialNo: item.materialNo || "",
          materialName: item.materialName || "",
          specifications: item.specifications || "",
          manufacturerModel: item.manufacturerModel || "",
          sapProductName: item.sapProductName || "",
          unit: item.unit || "",
          softInfo: item.softInfo || "",
          quantity: item.quantity || 1,
          initQuantity: item.initQuantity || 1,
          unitPrice: item.unitPrice || "",
          totalPrice: totalPrice.toFixed(2),
          totalNetPrice: totalNetPrice.toFixed(2),
          totalTaxPrice: totalTaxPrice,
          finalTotalPrice: finalTotalPrice.toFixed(2),
          finalTotalTaxPrice: finalTotalTaxPrice.toFixed(2),
          finalTotalNetPrice: finalTotalNetPrice.toFixed(2),
          discount: discount || 0,
          discountTaxPrice: discountTaxPrice || 0,
          taxRate: item.taxRate || 13,
          note: item.note || "",
          type: item.type || "",
          rowIndex: item.rowIndex || "",
          billNo: item.billNo || "",
          sapSaleOrderNo: item.sapSaleOrderNo || "",
          salesOrderRowIndex: item.salesOrderRowIndex || "",
          taxTypeSource: [matchTaxType],
          taxTypePkid:  matchTaxType.pkid,
          taxTypeCode: matchTaxType.code || "",
          taxTypeName: matchTaxType.typeName || "",
          rowKey: item.rowKey || this.getRowKey(),
        };
      },
      // 明细拆分相关方法
      splitDetail(row, type) {
        this.splitDetailData = JSON.parse(JSON.stringify(row));
        this.splitDetailType = type;
        this.splitDialogVisible = true;
      },
      // 根据名称查询税收分类编码
      getTaxTypeCodeByName(typeName) {
        // 判断是否有开票名称，有则查询出对应的code并赋值
        if(!typeName) {
          return {code: "", typeName: "", pkid: ""};
        }
        const filterData = this.taxTypeSource.filter(item => item.typeName === typeName);
        let code = "";
        if(filterData.length > 0) {
          code = filterData[0].code;
        }
        if(code) {
          return { code, typeName, pkid: filterData[0].pkid };
        }
        return {code: "", typeName: "", pkid: ""};
      },
      // 拆分明细 - 确认添加到开票信息中
      handleSplitConfirm(splitDetails) {
        // 从原列表中移除该明细
        if (this.splitDetailType === "delivery") {
          const index = this.deliveryList.findIndex(item => item.deliveryDetailId === this.splitDetailData.deliveryDetailId);
          if (index > -1) {
            this.deliveryList.splice(index, 1);
          }
        } else {
          const index = this.saleOrderList.findIndex(item => item.saleOrderDetailId === this.splitDetailData.saleOrderDetailId);
          if (index > -1) {
            this.saleOrderList.splice(index, 1);
          }
        }
        // 处理拆分后的数据
        splitDetails.forEach((splitItem) => {
          if (this.splitDetailType === "delivery") {
            // 发货单明细
            this.deliveryList.push({
              ...this.addDeliveryCommonItem(splitItem.originalData, ""), 
              ...splitItem,
            });
          } else {
            // 销售订单明细
            this.saleOrderList.push({
              ...this.addSaleOrderCommonItem(splitItem.originalData, ""), 
              ...splitItem,
            });
          }
        });
        // 更新开票金额
        this.splitDialogVisible = false;
      },
      addSapInvoice() {
        // this.btnItemLoading = true;
        // 批量处理，减少DOM更新次数
        const newDetails = [];
        const deliveryIdsToRemove = [];
        const saleOrderIdsToRemove = [];
        
        // 处理发货单
        if (this.deliverySelection.length > 0) {
          this.deliverySelection.forEach((item) => {
            let invoiceContent = item.sapProductName;
            if (this.form.softInfo === 1 && item.softInfo) {
              if (item.sapProductName) {
                invoiceContent = item.sapProductName + "（" + item.softInfo + "）";
              } else {
                invoiceContent = "（" + item.softInfo + "）";
              }
            }
            
            // 添加到临时数组
            newDetails.push({
              ...this.addInvoiceCommonItem({
                ...item,
                specifications: item.manufacturerModel,
                type: "发货单",
                note: "",
              }, invoiceContent),
              deliveryList: [{
                ...this.addDeliveryCommonItem(item, ""),
                note: "",
              }],
            });
            
            // 记录要删除的ID
            deliveryIdsToRemove.push({
              deliveryDetailId: item.deliveryDetailId,
              splitIndex: item.splitIndex,
            });
          });
          
          // 批量删除发货单
          this.deliveryList = this.deliveryList.filter(item => !deliveryIdsToRemove.some(rem => rem.deliveryDetailId === item.deliveryDetailId && rem.splitIndex === item.splitIndex));
        }
        
        // 处理销售订单
        if (this.saleOrderSelection.length > 0) {
          // 先检查是否有负数量的销售订单
          const hasNegativeQuantity = this.saleOrderSelection.some(item => item.quantity < 0);
          if (hasNegativeQuantity) {
            this.btnItemLoading = false;
            this.$message.error("销售订单明细开票数量不能为负数，不支持开票！");
          }
          const validateResult = this.saleOrderSelection.filter(item => item.quantity > 0);
          validateResult.forEach((item) => {
            let invoiceContent = item.sapProductName;
            if (this.form.softInfo === 1 && item.softInfo) {
              if (item.sapProductName) {
                invoiceContent = item.sapProductName + "（" + item.softInfo + "）";
              } else {
                invoiceContent = "（" + item.softInfo + "）";
              }
            }
            
            // 添加到临时数组
            newDetails.push({
              ...this.addInvoiceCommonItem({
                ...item,
                type: "销售订单",
                note: "",
              }, invoiceContent),
              saleOrderList: [{
                ...this.addSaleOrderCommonItem(item, ""),
                note: "",
              }],
            });
            
            // 记录要删除的ID
            saleOrderIdsToRemove.push({
              saleOrderDetailId: item.saleOrderDetailId,
              splitIndex: item.splitIndex,
            });
          });
          
          // 批量删除销售订单
          this.saleOrderList = this.saleOrderList.filter(item => !saleOrderIdsToRemove.some(rem => rem.saleOrderDetailId === item.saleOrderDetailId && rem.splitIndex === item.splitIndex)); // 考虑拆分出来的明细中，单号相同，所以需要考虑拆分索引
        }
        
        // 批量添加新明细
        if (newDetails.length > 0) {
          this.form.details = [...this.form.details, ...newDetails];
        }
        
        // 清空选择
        this.deliverySelection = [];
        this.saleOrderSelection = [];
        // 关闭loading状态
        // this.btnItemLoading = false;
      },
      countSapInvoice() {
        this.btnDifMaterialLoading = true;
        let allList = this.deliverySelection.concat(this.saleOrderSelection);
        let model = allList[0];
        if (allList.length > 0) {
          const deliveryList = [];
          const saleOrderList = [];
          const saleOrderListToRemove = [];
          const deliveryListToRemove = [];
          let initTotalPrice = 0;
          let initTotalNetPrice = 0;
          let initTotalTaxPrice = 0;
          let hsDiscount = 0;//折扣含税
          let discountTaxPrice = 0;//折扣税额
          allList.forEach((item) => {
            if (item.type === "销售订单") {
              if (item.quantity < 0) {
                hsDiscount += parseFloat(item.totalPrice);
                discountTaxPrice += parseFloat((item.totalPrice - item.totalNetPrice).toFixed(2));
              } else {
                initTotalPrice += parseFloat(item.totalPrice);
                initTotalNetPrice += parseFloat(item.totalNetPrice);
                initTotalTaxPrice += parseFloat((item.totalPrice - item.totalNetPrice).toFixed(2));
              }
              saleOrderList.push({
                ...this.addSaleOrderCommonItem(item, ""),
                note: "",
              });
              saleOrderListToRemove.push({
                saleOrderDetailId: item.saleOrderDetailId,
                splitIndex: item.splitIndex,
              });
            } else {
              initTotalPrice += parseFloat(item.totalPrice);
              initTotalNetPrice += parseFloat(item.totalNetPrice);
              initTotalTaxPrice += parseFloat((item.totalPrice - item.totalNetPrice).toFixed(2));
              deliveryList.push({
                ...this.addDeliveryCommonItem(item, ""),
                note: "",
              });
              deliveryListToRemove.push({
                deliveryDetailId: item.deliveryDetailId,
                splitIndex: item.splitIndex,
              });
            }
          });
          const params = {
            ...this.addInvoiceCommonItem({
              materialName: model.materialName,
              materialNo: model.materialNo,
              specifications: model.manufacturerModel,
              sapProductName: model.sapProductName,
              softInfo: model.softInfo,
              unit: model.unit,
              unitPrice: initTotalPrice,
              totalNetPrice: initTotalNetPrice,
              totalTaxPrice: initTotalTaxPrice,
              totalPrice: initTotalPrice,
              discount: hsDiscount,
              discountTaxPrice:discountTaxPrice,
              type: "汇总",
            }),
            deliveryList,
            saleOrderList,
          }; 
          this.form.details.push(params);
          this.saleOrderList = this.saleOrderList.filter(item => !saleOrderListToRemove.some(rem => rem.saleOrderDetailId === item.saleOrderDetailId && rem.splitIndex === item.splitIndex));
          this.deliveryList = this.deliveryList.filter(item => !deliveryListToRemove.some(rem => rem.deliveryDetailId === item.deliveryDetailId && rem.splitIndex === item.splitIndex));
        }
        this.deliverySelection = [];
        this.saleOrderSelection = [];
        this.$nextTick(() => {
          this.btnDifMaterialLoading = false;
        });
        // this.handDetail(allList);
      },
      countSapInvoiceByOtherNOByV2() {
        // this.btnMaterialLoading = true;
        // 准备有效的合并项
        const validItems = this.deliverySelection.concat(this.saleOrderSelection);
        if (validItems.length < 2) {
          // this.$nextTick(() => {
          //   this.btnMaterialLoading = false;
          // });
          return this.$message.error("可进行汇总开票的明细行必须大于2");
        }
        // 检查是否全部为负数量的销售订单
        const allSaleOrder = validItems.every(item => item.type === "销售订单" && item.quantity < 0);
        if (allSaleOrder) {
          // this.$nextTick(() => {
          //   this.btnMaterialLoading = false;
          // });
          return this.$message.error("全部为负数量的销售订单不能进行合并");
        }
        // 按物料号和单价分组
        const groupedItems = {};
        validItems.forEach(item => {
          const key = `${item.materialNo}_${item.unitPrice}`;
          if (!groupedItems[key]) {
            groupedItems[key] = [];
          }
          groupedItems[key].push(item);
        });
          
        // 检查负数量销售订单是否可以合并
        let validSaleOrders = [];
        let validDelivery = [];
        const validSaleOrderToRemove = [];
        const validDeliveryToRemove = [];
        // 处理每个分组
        let hasFuSaleOrder = false;
        Object.values(groupedItems).forEach(items => {
          if (items.length > 0) {
            let totalQuantity = 0;
            let totalDiscount = 0;
            let totalDiscountTaxPrice = 0;
            let invoiceContent = items[0].sapProductName;
              
            // 处理软著信息
            if (this.form.softInfo === 1 && items[0].softInfo) {
              if (items[0].sapProductName) {
                invoiceContent = items[0].sapProductName + "（" + items[0].softInfo + "）";
              } else {
                invoiceContent = "（" + items[0].softInfo + "）";
              }
            }
            // 销售订单为负数，且要生成单独的开票明细，将此明细记录下来
            if(items.every(item => item.type === "销售订单" && item.quantity < 0)) {
              hasFuSaleOrder = true;
              return;
            }
            // 如果包含销售订单和发货单，且发货单中包含不包含赠送标识的发货单，且销售订单中包含负数量的销售订单，则不能合并开票
            // let hasNoGiftFlag = items.some(item => item.type === "发货单" && item.give !== "X") && items.some(item => item.type === "销售订单" && item.quantity < 0);
            // if(hasNoGiftFlag) {
            //   this.$message.error("不包含赠送标识的发货订单不能与数量为负数的销售订单进行汇总开票");
            //   return; 
            // }
         
            // 计算数量和折扣
            validSaleOrders = [];
            validDelivery = [];
            items.forEach(item => {
              item.totalTaxPrice = parseFloat(item.totalPrice - item.totalNetPrice).toFixed(2);
              if(item.type === "销售订单") {
                validSaleOrders.push(item);
                validSaleOrderToRemove.push({
                  saleOrderDetailId: item.saleOrderDetailId,
                  splitIndex: item.splitIndex,
                });
              }
              if(item.type === "发货单") {
                validDelivery.push(item);
                validDeliveryToRemove.push({
                  deliveryDetailId: item.deliveryDetailId,
                  splitIndex: item.splitIndex,
                });
              }
              if (item.type === "销售订单" && item.quantity < 0) {
                // 负数量销售订单，计算折扣
                const discountAmount = item.quantity * item.unitPrice;
                const taxRate = item.taxRate || 13;
                const discountNetPrice = discountAmount / (1 + taxRate / 100);
                const discountTaxPrice = discountAmount - discountNetPrice;
                  
                totalDiscount += discountAmount;
                totalDiscountTaxPrice += discountTaxPrice;
              } else {
                // 正数量项，计入数量合计
                totalQuantity += item.quantity;
              }
            });
              
            // 计算总金额
            const unitPrice = items[0].unitPrice;
            const countTotalPrice = parseFloat(totalQuantity * unitPrice).toFixed(2);
            const taxRate = items[0].taxRate || 13;
            const countTotalNetPrice = parseFloat(countTotalPrice / (1 + taxRate / 100)).toFixed(2);
              
            // 创建新的开票明细
            const isSum = items.length > 1; // 是否是汇总开票
            let model = {
              ...this.addInvoiceCommonItem({
                ...items[0],
                specifications: items[0].manufacturerModel,
                quantity: totalQuantity,
                initQuantity: totalQuantity,
                totalPrice: countTotalPrice,
                totalNetPrice: countTotalNetPrice,
                note: "",
                type: isSum ? "汇总" : items[0].type,
                discount: parseFloat(totalDiscount).toFixed(2),
                discountTaxPrice: parseFloat(totalDiscountTaxPrice).toFixed(2),
              }, invoiceContent),
            };
            // 添加子项明细
            model.saleOrderList = validSaleOrders;
            model.deliveryList = validDelivery;
              
            // 需求5：添加新的开票明细
            this.form.details.push(model);
          }
        });

        if(hasFuSaleOrder) {
          this.$message.error("数量为负的销售订单不能单独开票");
        }
        // 需求3：从原关联列表中移除已合并的项
        // 移除已合并的发货单 / 销售订单
        this.saleOrderList = this.saleOrderList.filter(item => !validSaleOrderToRemove.some(rem => rem.saleOrderDetailId === item.saleOrderDetailId && rem.splitIndex === item.splitIndex));
        this.deliveryList = this.deliveryList.filter(item => !validDeliveryToRemove.some(rem => rem.deliveryDetailId === item.deliveryDetailId && rem.splitIndex === item.splitIndex));
          
        // 清空选择
        this.deliverySelection = [];
        this.saleOrderSelection = [];
          
        // this.$nextTick(() => {
        //   this.btnMaterialLoading = false;
        // });
        // 这里将关联列表勾选重置掉
        if(this.$refs.refDelivery) {
          this.$refs.refDelivery.clearSelection();
        }
        if(this.$refs.refSaleOrder) {
          this.$refs.refSaleOrder.clearSelection();
        }
      },
      deleteRow(index, row) {
        let params = {};
        if (row.deliveryList && row.deliveryList.length > 0) {
          row.deliveryList.forEach((item) => {
            params = this.addDeliveryCommonItem(item);
            this.deliveryList.push(params);
          });
        }
     
        if (row.saleOrderList && row.saleOrderList.length > 0) {
          row.saleOrderList.forEach((item) => {
            params = this.addSaleOrderCommonItem(item);
            this.saleOrderList.push(params);
          });
        }
        this.form.details.splice(index, 1);
      },
      deleteRowByFinancial(index) {
        this.form.details.splice(index, 1);
      },
      getDetailData(id,cancelId) {
        let url = cancelId ? `invoiceApplications/getCancelVo/${cancelId}` : `invoiceApplications/${id}/${this.edit === 1 ? 1 : 0}`;
        this.$http.get("basic", url).then((resp) => {
          this.form = resp.data;
          this.deliveryList = JSON.parse(JSON.stringify(resp.data.deliveryList)).map((itm) => {
            return {
              ...itm,
              initQuantity: itm.initQuantity || itm.quantity,
            };
          });
          this.saleOrderList = JSON.parse(JSON.stringify(resp.data.saleOrderList)).map((itm) => {
            return {
              ...itm,
              initQuantity: itm.initQuantity || itm.quantity,
            };
          });
          if (this.form.details.length > 0) {
            this.form.details.forEach((item) => {
              // item.countList = item.deliveryList.concat(item.saleOrderList);
              item.totalPrice = item.quantity * item.unitPrice;
              this.$set(item, "taxTypeSource", {
                code: item.taxTypeCode || "",
                typeName: item.taxTypeName || "",
                pkid: item.taxTypePkid || "",
              });
              item.deliveryList.forEach((deliveryItem) => {
                this.$set(deliveryItem, "totalTaxPrice", parseFloat(deliveryItem.totalPrice - deliveryItem.totalNetPrice).toFixed(2));
              });
              item.saleOrderList.forEach((saleOrderItem) => {
                this.$set(saleOrderItem, "totalTaxPrice", parseFloat(saleOrderItem.totalPrice - saleOrderItem.totalNetPrice).toFixed(2));
              });
            });
          }
          this.form.invoiceType = this.form.invoiceType || "05";
        }).finally(() => {
          this.contentLoading = false;
        });
      },
      getData(id, selection, cancelId) {
        if (id > 0) {
          if(this.routeBillId === id) {
            return;
          }
          this.routeBillId = id;
          this.contentLoading = true;
          this.edit = 0;
          this.getDetailData(id);
        } else if (cancelId > 0) {
          if (this.routeCancelId === cancelId) {
            return;
          }
          this.routeCancelId = cancelId;
          this.contentLoading = true;
          // 开票红冲
          this.isEdit = true;
          this.edit = 1;
          this.getDetailData(id,cancelId);
        } else {
          this.edit = 1;
          const selectionIds = selection.map(item => item.type + item.billId).join("*");
          if (this.routeSelection === selectionIds) {
            return;
          }
          this.routeSelection = selectionIds;
          this.contentLoading = true;
          if (selection.length > 0) {
            this.$http.post("basic", "invoiceApplications/getDetails", selection).then((resp) => {
              this.form = resp.data;
              this.form.cancelSign=false;
              this.deliveryList = JSON.parse(JSON.stringify(resp.data.deliveryList));
              this.saleOrderList = JSON.parse(JSON.stringify(resp.data.saleOrderList));
              this.deliveryList.forEach((item) => {
                item.initQuantity = item.quantity;
              });
              this.saleOrderList.forEach((item) => {
                item.initQuantity = item.quantity;
              });
              const detailDeliverys = [];
              if (this.form.details.length > 0) {
                this.form.details.forEach((item) => {
                  this.$set(item, "taxTypeSource", {
                    code: item.taxTypeCode || "",
                    typeName: item.taxTypeName || "",
                    pkid: item.taxTypePkid || "",
                  });
                  if (item.type === "发货单" && item.deliveryList && item.deliveryList.length > 0) {
                    item.deliveryList.forEach((deliveryItem) => {
                      this.$set(deliveryItem, "initQuantity", deliveryItem.quantity);
                      this.$set(deliveryItem, "totalTaxPrice", parseFloat(deliveryItem.totalPrice - deliveryItem.totalNetPrice).toFixed(2));
                      this.$set(deliveryItem, "invoiceContent", item.invoiceContent);
                      this.$set(deliveryItem, "taxRate", item.taxRate || 13);

                      detailDeliverys.push(this.addDeliveryCommonItem({
                        ...deliveryItem,
                        invoiceContent: item.invoiceContent,
                        initQuantity: deliveryItem.quantity,
                        taxRate: item.taxRate || 13,
                      }));
                    });
                  }
                });
              }
              this.form.invoiceType = this.form.invoiceType || "05";
              this.allList = this.deliveryList.concat(this.saleOrderList, detailDeliverys);
              this.judgeInvoiceContent();
              this.contentLoading = false;
            }).catch(() => {
            });
          } else {
            this.form.pkId = "";
            this.form.billNo = "";
            this.form.customerId = "";
            this.form.customerName = "";
            this.form.customerNo = "";
            this.form.invoiceVATNO = "";
            this.form.invoiceAddress = "";
            this.form.invoiceAccounts = "";
            this.form.financialVouchers = "";
            this.form.email = "";
            this.form.sign = "财务";
            this.form.invoiceTotalAmount = "";
            this.form.note = "";
            this.form.details = [];
            this.form.totalNetPrice = "";
            this.form.totalTaxPrice = "";
            this.form.invoiceType = "05";
            this.form.invoiceStatus = "1";
            this.form.referencecode = "";
            this.form.softInfo = "";
            this.contentLoading = false;
          }
        }
      },
      getEditData(id) {
        this.contentLoading = true;
        this.getDetailData(id);
      },
      deliverySelectHandle(selection) {
        this.deliverySelection = selection;
      },
      saleOrderSelectHandle(selection) {
        this.saleOrderSelection = selection;
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/upload", formData)
          .then((res) => {
            this.uploadLoading = false;
            console.log(res);
            this.form.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      validateInvoiceItemAmount() {
        // 校验开票信息明细form.details中的实际金额（含税，未税，税额）=开票金额+折扣
        // 校验开票信息明细form.details中的实际金额（含税，未税，税额）=sum(子表form.details.deliveryList + saleOrderList +  countList的金额)
        const errorMsgs = [];
        const addErrorMsg = (index, msg) => {
          if (errorMsgs.find(item => item.index === index)) {
            errorMsgs.forEach(item => {
              if (item.index === index) {
                item.msg += msg;
              }
            });
          } else {
            errorMsgs.push({
              index: index,
              msg: msg,
            });
          }
        };
        this.form.details.forEach((detail, index) => {
          // 计算开票金额+折扣
          const totalPrice = parseFloat(detail.totalPrice) || 0;
          const totalNetPrice = parseFloat(detail.totalNetPrice) || 0;
          const discount = parseFloat(detail.discount) || 0;
          const discountTaxPrice = parseFloat(detail.discountTaxPrice) || 0;
          const discountNetPrice = parseFloat(discount - discountTaxPrice) || 0;
          const finalTotalPrice = parseFloat(detail.finalTotalPrice) || 0;
          const finalTotalTaxPrice = parseFloat(detail.finalTotalTaxPrice) || 0;
          const finalTotalNetPrice = parseFloat(detail.finalTotalNetPrice) || 0;

          // 校验实际金额=开票金额+折扣
          if (Math.abs(finalTotalPrice  - (totalPrice + discount)) > 0.05) {
            addErrorMsg(index, `实际开票金额(含税): ${finalTotalPrice.toFixed(2)}与开票金额（含税） + 折扣: ${(totalPrice + discount).toFixed(2)}不相等；`);
          }
         
          if (Math.abs(finalTotalNetPrice - (totalNetPrice + discountNetPrice)) > 0.05) {
            addErrorMsg(index, `实际开票金额(不含税): ${finalTotalNetPrice.toFixed(2)}与开票总额(不含税) + 折扣税额(不含税): ${(totalNetPrice + discountNetPrice).toFixed(2)}不相等；`);
          }
          if (Math.abs(finalTotalTaxPrice - (finalTotalPrice - finalTotalNetPrice)) > 0.05) {
            addErrorMsg(index, `实际税额: ${finalTotalTaxPrice.toFixed(2)}与实际开票金额(含税) - 实际开票金额(不含税): ${(finalTotalPrice - finalTotalNetPrice).toFixed(2)}不相等；`);
          }
        });
        if (errorMsgs.length > 0) {
          const errorMsg = errorMsgs.map(item => `开票明细第${item.index + 1}行：${item.msg}`).join("\n");
          this.$message.error(errorMsg);
          return false;
        }
        this.form.details.forEach((detail, index) => {
          // 计算子表金额总和
          let subTotalPriceTotal = 0; // 含税
          let subTotalNetPriceTotal = 0; // 不含税
          let subTotalTaxPriceTotal = 0; // 税率
          // 检查deliveryList
          if (detail.deliveryList && detail.deliveryList.length > 0) {
            for (let item of detail.deliveryList) {
              subTotalPriceTotal += parseFloat(item.totalPrice) || 0;
              subTotalNetPriceTotal += parseFloat(item.totalNetPrice) || 0;
              subTotalTaxPriceTotal += parseFloat(item.totalTaxPrice) || 0;
            }
          }
          // 检查saleOrderList
          if (detail.saleOrderList && detail.saleOrderList.length > 0) {
            for (let item of detail.saleOrderList) {
              subTotalPriceTotal += parseFloat(item.totalPrice) || 0;
              subTotalNetPriceTotal += parseFloat(item.totalNetPrice) || 0;
              subTotalTaxPriceTotal += parseFloat(item.totalTaxPrice) || 0;
            }
          }
          // 校验实际金额=子表金额总和
          if (Math.abs(detail.finalTotalPrice - subTotalPriceTotal) > 0.05) {
            addErrorMsg(index, `实际开票金额(含税): ${parseFloat(detail.finalTotalPrice).toFixed(2)}与关联明细表开票总额(含税)总和: ${parseFloat(subTotalPriceTotal).toFixed(2)}不相等；`);
          }
          if (Math.abs(detail.finalTotalNetPrice - subTotalNetPriceTotal) > 0.05) {
            addErrorMsg(index, `实际开票金额(不含税): ${parseFloat(detail.finalTotalNetPrice).toFixed(2)}与关联明细表开票总额(不含税)总和: ${parseFloat(subTotalNetPriceTotal).toFixed(2)}不相等；`);
          }
          if (Math.abs(detail.finalTotalTaxPrice - subTotalTaxPriceTotal) > 0.05) {
            addErrorMsg(index, `实际税额: ${parseFloat(detail.finalTotalTaxPrice).toFixed(2)}与关联明细表税额总和: ${parseFloat(subTotalTaxPriceTotal).toFixed(2)}不相等；`);
          }
        });
        if (errorMsgs.length > 0) {
          const errorMsg = errorMsgs.map(item => `开票明细第${item.index + 1}行：${item.msg}`).join("\n");
          this.$message.error(errorMsg);
          return false;
        }
        return true;
      },
      saveHandle() {
        let isNext = true;
        let message = "";
        if (this.form.details.length <= 0) {
          return this.$message.error("开票信息不能为空！");
        } else {
          this.form.details.forEach(item => {
            if (item.invoiceContent === "") {
              message = "开票名称不能为空！";
              isNext = false;
            } else if (item.materialNo === "") {
              message = "物料编号不能为空！";
              isNext = false;
            } else if (item.specifications === "") {
              message = "规格型号不能为空！";
              isNext = false;
            } else if (item.unit === "") {
              isNext = false;
              message = "单位不能为空！";
            } else if (item.quantity === "") {
              isNext = false;
              message = "数量不能为空！";
            } else if (item.unitPrice === "") {
              isNext = false;
              message = "开票单价不能为空！";
            } else if (item.totalPrice === "") {
              isNext = false;
              message = "开票金额不能为空！";
            } else if (item.taxTypeCode === "") {
              isNext = false;
              message = "税收分类编码不能为空！";
            }
          });

        }
        if (this.form.sign === "销售") {
          if ((this.deliveryList.length > 0 || this.saleOrderList.length > 0) && !this.isEdit) {
            return this.$message.error("存在未开票的行项目！");
          }
        }
        if (isNext) {
          if (!this.validateInvoiceItemAmount()) { return; }
          // 校验父级明细总和与基本信息中的开票金额是否相等
          if (Math.abs(this.detailsInvoiceTotalAmount - parseFloat(this.form.invoiceTotalAmount)) > 0.5) {
            this.$message.error("开票信息明细的开票总额（含税）总和与基本信息中的开票金额差额超出0.5元，请检查！");
            return false;
          }
          delete this.form.deliveryList;
          delete this.form.saleOrderList;
          this.submitLoading = true;
          if (this.isEdit && this.form.pkId>0) {
            this.$http.put("basic", "invoiceApplications", this.form)
              .then(() => {
                // 关闭标签
                this.$bus.$emit("closeTag", this.$route);
                // 等待标签关闭后再跳转
                setTimeout(() => {
                  this.$router.push({
                    path: "/SalesManage/InvoiceApplication/InvoiceListApplicationList",
                  });
                }, 100);
              }).finally(() => {
                this.submitLoading = false;
              });
          } else {
            this.$http.post("basic", "invoiceApplications", this.form)
              .then(() => {
                // 关闭标签
                this.$bus.$emit("closeTag", this.$route);
                // 等待标签关闭后再跳转
                setTimeout(() => {
                  this.$router.push({
                    path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
                  });
                }, 100);
              }).finally(() => {
                this.submitLoading = false;
              });
          }
        } else {
          return this.$message.error(message);
        }
      },
      submit() {
        // 校验父级明细总和与基本信息中的开票金额是否相等
        if (!this.validateInvoiceAmount()) {
          return;
        }
        // this.$http.post("basic", "invoiceApplications/saveAndSubmit", this.form)
        //   .then(() => {
        //     // 关闭标签
        //     this.$bus.$emit("closeTag", this.$route);
        //     // 等待标签关闭后再跳转
        //     setTimeout(() => {
        //       this.$router.push({
        //         path: "/SalesManage/InvoiceApplication/ToDoInvoiceList",
        //       });
        //     }, 100);
        //   }).catch(() => {
        //     this.$message.error("保存失败");
        //     this.submitLoading = false;
        //   });
      },
      selectCustomerName(row) {
        this.form.customerId = row.customerID;
        this.form.customerName = row.customerName;
        this.form.customerNo = row.outerNo;
        this.form.invoiceVATNO = row.vatno;
        this.form.invoiceAccounts = row.accounts;
        this.form.invoiceAddress = row.address;
        this.form.email = row.email;
      },
      addFinancialDetails() {
        let obj = {
          invoiceContent: "",
          materialNo: "",
          materialName: "",
          specifications: "",
          unit: "",
          quantity: "",
          unitPrice: "",
          totalPrice: "",
          note: "",
          rowIndex: "",
          type: "",
          deliveryBillId: "",
          deliveryDetailId: "",
          billNo: "",
          taxType: {code: "", typeName: ""},
          taxTypeCode: "",
          taxTypeName:  "",
        };
        this.form.details.push(obj);
      },
      invoiceContentChange(row) {
        if (this.form.softInfo === 1) {
          if (!row.invoiceContent.includes(row.softInfo)) {
            row.invoiceContent = row.invoiceContent + "（" + row.softInfo + "）";
          }
        }

      },
      changeQuantity(row) {
        row.totalPrice = parseFloat(row.quantity * row.unitPrice).toFixed(2);
        let taxRate = (row.taxRate / 100) + 1;
        row.totalNetPrice = parseFloat(row.totalPrice / taxRate).toFixed(2);
        this.calculateBaseTotalAmount(row);
      },
      // 根据发货列表/销售订单列表计算基本信息中的开票总金额
      calculateBaseTotalAmount(row) {
        // 存储原始列表行，用于计算基本信息中的金额
        // 更新allList中对应行的数据
        // 先在deliveryList中查找
        if (row.deliveryDetailId) {
          const deliveryIndex = this.allList.findIndex(item => item.deliveryDetailId === row.deliveryDetailId);
          this.$set(this.allList, deliveryIndex, row);
        } else {
          // 再在saleOrderList中查找
          const saleOrderIndex = this.allList.findIndex(item => item.saleOrderDetailId === row.saleOrderDetailId);
          if (saleOrderIndex !== -1) {
            this.$set(this.allList, saleOrderIndex, row);
          }
        }
        // 计算基本信息中的总金额、总税额、总不含税金额 
        let invoiceTotalAmount = 0;
        let totalNetPrice = 0;
        let totalTaxPrice = 0;

        // 计算基本信息里的汇总信息
        this.allList.forEach((item) => {
          const itemTotalPrice = parseFloat(item.totalPrice) || 0;
          const itemTotalNetPrice = parseFloat(item.totalNetPrice) || 0;

          invoiceTotalAmount += itemTotalPrice;
          totalNetPrice += itemTotalNetPrice;
          totalTaxPrice += parseFloat(itemTotalPrice - itemTotalNetPrice); // 税额 = 含税金额 - 不含税金额
        });

        this.form.invoiceTotalAmount = invoiceTotalAmount.toFixed(2);
        this.form.totalNetPrice = totalNetPrice.toFixed(2);
        this.form.totalTaxPrice = totalTaxPrice.toFixed(2);
        this.judgeInvoiceContent();
      },
      softInfoChange() {
        console.log(this.form.details);
        if (this.form.softInfo === 1) {
          this.form.details.forEach((row) => {
            if (!row.invoiceContent.includes(row.softInfo)) {
              row.invoiceContent = row.invoiceContent + "（" + row.softInfo + "）";
            }
          });
        } else {
          this.form.details.forEach((row) => {
            if (row.invoiceContent.includes(row.softInfo)) {
              row.invoiceContent = row.invoiceContent.split("（" + row.softInfo + "）").join("");
            }
          });
        }
      },
      // 计算开票明细中的最终开票金额、税额、不含税金额
      /**
       *
       * 实际开票金额（含税） = 开票总额（含税） + 折扣额（含税），其中折扣额是负数，所以要相加
       * 实际税额 = 税额 + 折扣税额 ，其中折扣税额是负数，所以要相加
       * 实际开票金额（不含税） = 实际开票金额（含税）- 实际税额
       */
      calcuteItemFinalPrice(row) {
        // 确保所有值都被正确转换为数字
        const discount = parseFloat(row.discount) || 0;
        const totalPrice = parseFloat(row.totalPrice) || 0;
        const totalNetPrice = parseFloat(row.totalNetPrice) || 0;
        const discountNetPrice = parseFloat(row.discountNetPrice) || discount / (1 + row.taxRate/100);
        // 计算明细行的实际开票金额（含税） = 开票总额（含税） + 折扣额（含税）
        row.finalTotalPrice = (totalPrice + discount).toFixed(2);
        // 计算明细行的实际开票金额（不含税） = 实际开票金额（含税） - 实际税额
        row.finalTotalNetPrice = (totalNetPrice + discountNetPrice).toFixed(2);
        // 计算明细行的实际税额 = 税额 + 折扣税额
        row.finalTotalTaxPrice = parseFloat(row.finalTotalPrice - row.finalTotalNetPrice).toFixed(2);
        // 确保结果是有效的数字
        if (isNaN(row.finalTotalPrice)) row.finalTotalPrice = 0;
        if (isNaN(row.finalTotalTaxPrice)) row.finalTotalTaxPrice = 0;
        if (isNaN(row.finalTotalNetPrice)) row.finalTotalNetPrice = 0;
        // 重新计算开票信息明细的合计值
        // this.calculateDetailsTotalAmount();
      },
      // 计算折扣税额
      calculateDiscountTaxPrice(row) {
        // 根据输入的折扣额计算折扣税额
        // 折扣税额 = 折扣额(含税) - 折扣额(不含税)
        const discount = parseFloat(row.discount) || 0;
        const taxRate = parseFloat(row.taxRate) || 0;
        const taxRateDecimal = 1 + taxRate / 100;
        row.discountNetPrice = parseFloat(discount / taxRateDecimal).toFixed(2);
        row.discountTaxPrice = parseFloat(discount - row.discountNetPrice).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      // 税率改变时，对应税额 折扣税额进行联动
      handleInvoiceTaxChange(row) {
        const taxRateDecimal = 1 + row.taxRate / 100;
        row.totalNetPrice = (row.totalPrice / taxRateDecimal).toFixed(2); // 开票金额总价(不含税) = 开票金额总价(含税) / (1 + 税率)
        row.totalTaxPrice = (row.totalPrice - row.totalNetPrice).toFixed(2); // 开票金额税额 = 开票金额总价(含税) - 开票金额总价(不含税)
        this.calculateDiscountTaxPrice(row);
      },
      // 开票数量和开票单价改变时，对应开票金额，税额，及最终开票金额等进行联动
      handleInvoiceCountChange(row) {
        row.totalPrice = (parseFloat(row.quantity) * parseFloat(row.unitPrice)).toFixed(2); // 开票金额总价(含税) = 开票单价 * 开票数量
        row.totalNetPrice = (parseFloat(row.totalPrice) / parseFloat(1 + row.taxRate / 100)).toFixed(2); // 开票金额总价(不含税) = 开票金额总价(含税) / (1 + 税率)
        row.totalTaxPrice = (parseFloat(row.totalPrice) - parseFloat(row.totalNetPrice)).toFixed(2); // 开票金额税额 = 开票金额总价(含税) - 开票金额总价(不含税)
        this.calcuteItemFinalPrice(row);
      },
      // 开票总额(不含税) / 税额改变时，对应开票金额税额进行联动
      calculateInvoiceTotalPrice(row) {
        row.totalPrice = (parseFloat(row.totalTaxPrice) + parseFloat(row.totalNetPrice)).toFixed(2);
        this.calcuteItemFinalPrice(row);
      },
      // 判断开票总金额的值，对应给发票状态赋值
      judgeInvoiceContent() {
        // 根据发票总金额自动设置发票状态
        if (this.form.invoiceTotalAmount > 0) {
          this.form.invoiceStatus = "1"; // 蓝票
        } else if (this.form.invoiceTotalAmount < 0) {
          this.form.invoiceStatus = "2"; // 红票
        }
        // 如果invoiceTotalAmount为0，则保持原发票状态
      },
      /**
       * 校验父级明细的开票总额（含税）总和与基本信息中的开票金额是否相等
       * @returns {boolean} 是否通过校验
       */
      validateInvoiceAmount() {
        // 校验父级明细总和与基本信息中的开票金额是否相等
        if (Math.abs(this.detailsInvoiceTotalAmount - parseFloat(this.form.invoiceTotalAmount)) > 0.5) {
          this.$message.error("开票信息明细的开票总额（含税）总和与基本信息中的开票金额差额超出0.5元，请检查！");
          return false;
        }
        return true;
      },

      selectCode(row, value) {
        const taxType = row.taxTypeSource.filter(item => item.typeName === value)[0];
        this.$set(row, "taxTypeName", taxType.typeName);
        this.$set(row, "taxTypeCode", taxType.code);
        this.$set(row, "taxTypePkid", taxType.pkid);
      },
    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
  word-break: break-all;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 340px;
  text-align: left;
  white-space: pre-wrap;
}

.detailTableLabel {
  width: 100px;
  text-align: left;
  background-color: #D1E6F5;
}


</style>